var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtopicNotesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3047 27.9922C22.9321 27.9922 28.3047 22.6196 28.3047 15.9922C28.3047 9.36477 22.9321 3.99219 16.3047 3.99219C9.67727 3.99219 4.30469 9.36477 4.30469 15.9922C4.30469 22.6196 9.67727 27.9922 16.3047 27.9922Z",
    fill: "url(#paint0_linear_3930_6651)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 10.7598H12.4167C11.775 10.7598 11.25 11.2848 11.25 11.9264V20.0931C11.25 20.7348 11.775 21.2598 12.4167 21.2598H20.5833C21.225 21.2598 21.75 20.7348 21.75 20.0931V11.9264C21.75 11.2848 21.225 10.7598 20.5833 10.7598ZM17.0833 18.9264H14.1667C13.8458 18.9264 13.5833 18.6639 13.5833 18.3431C13.5833 18.0223 13.8458 17.7598 14.1667 17.7598H17.0833C17.4042 17.7598 17.6667 18.0223 17.6667 18.3431C17.6667 18.6639 17.4042 18.9264 17.0833 18.9264ZM18.8333 16.5931H14.1667C13.8458 16.5931 13.5833 16.3306 13.5833 16.0098C13.5833 15.6889 13.8458 15.4264 14.1667 15.4264H18.8333C19.1542 15.4264 19.4167 15.6889 19.4167 16.0098C19.4167 16.3306 19.1542 16.5931 18.8333 16.5931ZM18.8333 14.2598H14.1667C13.8458 14.2598 13.5833 13.9973 13.5833 13.6764C13.5833 13.3556 13.8458 13.0931 14.1667 13.0931H18.8333C19.1542 13.0931 19.4167 13.3556 19.4167 13.6764C19.4167 13.9973 19.1542 14.2598 18.8333 14.2598Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3930_6651",
    x1: 16.3047,
    y1: 3.99219,
    x2: 16.3047,
    y2: 27.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtopicNotesIcon);
export default __webpack_public_path__ + "static/media/subtopic-notes-icon.ab5c3be88f26180b35b50192b3f3cadb.svg";
export { ForwardRef as ReactComponent };